import React from 'react';
import styled from 'styled-components';
import { AssignedTitles } from '@warehouse/object-browser/feature-show-assigned-titles';
import { ProxyPlayerSection } from '@warehouse/object-browser/feature-proxy-player';
import { GeneralInfos } from './GeneralInfos';
import { ExternalIntegrations } from './ExternalIntegrations';
import { DeleteObject } from './DeleteObject';

export function GeneralTab() {
	return (
		<PaddingWrapper>
			<ProxyPlayerSection />
			<GeneralInfos />
			<AssignedTitles />
			<ExternalIntegrations />
			<DeleteObject />
		</PaddingWrapper>
	);
}

export const PaddingWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: 'calc(100vh - 128px)',
    padding: theme.spacing(3, 2),
    boxSizing: 'border-box',

    '& body': {
        overflow: 'hidden !important',
    },
}));
